<template xmlns="http://www.w3.org/1999/html">
  <vs-col class="tickets-container">
    <div v-if="tickets.length > 1">
      <vs-col
        v-for="(ticket, index) in tickets"
        :key="'p' + index"
        :style="' height: ' + heightCard + 'vh;'"
        class="tickets row"
      >
        <div class="ticket" :style="'color: ' + config.colorText">
          <div
            class="ticket-top"
            :style="'background-color: ' + config.colorSecondary"
          >
            {{
              config.textNumber &&
              config.textNumber != "" &&
              config.textNumber != " "
                ? config.textNumber
                : "Numéro"
            }}
          </div>
          <div
            class="ticket-bottom"
            :style="
              ticket.public_identifier.replace('-', '').length > 3
                ? 'font-size: 2rem; background-color:' + config.color
                : ticket.public_identifier.replace('-', '').length == 3
                ? 'font-size: 4rem; background-color: ' + config.color
                : 'font-size: 5rem; background-color: ' + config.color
            "
          >
            {{ ticket.public_identifier.replace("-", "") }}
          </div>
        </div>
        <div class="ticket" :style="'color: ' + config.colorText">
          <div
            class="ticket-top"
            :style="'background-color: ' + config.colorSecondary"
          >
            {{
              config.textCounter &&
              config.textCounter != "" &&
              config.textCounter != " "
                ? config.textCounter
                : "Guichet"
            }}
          </div>
          <div
            class="ticket-bottom"
            :style="
              ticket.counter_name.length > 3
                ? 'font-size: 2rem; background-color:' + config.color
                : ticket.counter_name.length == 3
                ? 'font-size: 4rem; background-color: ' + config.color
                : 'font-size: 5rem; background-color: ' + config.color
            "
          >
            {{ ticket.counter_name }}
          </div>
        </div>
      </vs-col>
    </div>
    <div v-else-if="tickets.length !== 0">
      <div v-for="(ticket, index) in tickets" :key="'p' + index">
        <div class="solo-ticket" :style="'color: ' + config.colorText">
          <div style="height: 90%; width: 32vw">
            <div
              class="ticket-top"
              :style="'background-color: ' + config.colorSecondary"
            >
              {{
                config.textCounter &&
                config.textCounter != "" &&
                config.textCounter != " "
                  ? config.textCounter
                  : "Guichet"
              }}
              {{ ticket.counter_name ? ticket.counter_name : "--" }}
            </div>
            <div
              class="ticket-bottom"
              :style="
                ticket.public_identifier.replace('-', '').length > 3
                  ? 'font-size: 4.25rem; background-color: ' + config.color
                  : ticket.public_identifier.replace('-', '').length == 3
                  ? 'font-size: 8.5rem; background-color: ' + config.color
                  : 'font-size: 11rem; background-color: ' + config.color
              "
            >
              {{ ticket.public_identifier.replace("-", "") }}
            </div>
          </div>
        </div>
      </div>
      <div class="waiting-tickets" v-if="activeList.length != 0">
        <h3 :style="'color:' + config.color">
          {{ $t("Display.App.Next") }}
        </h3>
        <div class="waiting-ticket-list" :style="'color: ' + config.colorText">
          <table>
            <tbody>
              <tr>
                <td
                  v-for="waiting in activeList.slice(0, 3)"
                  :key="waiting"
                  :style="
                    waiting.length >= 3
                      ? 'font-size: 2em; background-color: ' +
                        config.colorSecondary
                      : 'font-size: 3em; background-color: ' +
                        config.colorSecondary
                  "
                >
                  {{ waiting.replace("-", "") }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div v-else></div>
  </vs-col>
</template>
<script>
import { displayService } from "../../_services";

export default {
  name: "WaitingList",
  data: () => ({
    title: "Waiting List",
    waitingListCardWidth: 30,
    targetCounter: null,
    timeLeft: 0,
    waitingLists: [],
    ticketNumber: null,
    counter: null,
    statusUpdateTimestamp: "",
    estimatedTimeToSpend: 0,
    old_waitingList: [],
    activeList: [],
    i: 0,
    heightCard: 0,
    colorPrimary: "",
    colorSecondary: "",
    colorText: "",
    show_approx_time: true,
    config: {
      voiceNumber: "",
      voiceCounter: "",
    },
  }),
  props: {
    queues_ids: String,
    queues: Array,
    tickets: Array,
    nextTickets: Array,
  },
  watch: {
    tickets: function () {
      // watch it
      this.setWaitingListCardWidth(this.tickets);
      if (this.tickets.length === 1) this.heightCard = 100;
      else this.heightCard = 95 / this.tickets.length;
      if (this.tickets.length == 1) {
        console.log("dddddddd", this.nextTickets);
        this.setActiveList(this.nextTickets);
      }
    },
  },
  methods: {
    setWaitingListCardWidth(activeList) {
      console.log("activeList: ", this.activeList);
      if (activeList.length >= 3) this.waitingListCardWidth = 10;
      else if (activeList.length == 2) this.waitingListCardWidth = 15;
      else this.waitingListCardWidth = 30;
    },
    notify(title, text, type) {
      this.$vs.notify({
        color: type,
        title: title,
        text: text,
      });
    },
    showLoading() {
      this.$vs.loading({
        container: "#queue-box",
        scale: 0.6,
      });
    },
    hideLoading() {
      this.$vs.loading.close("#queue-box > .con-vs-loading");
    },
    setActiveList(data) {
      this.activeList = [];
      console.log("width:" + this.waitingListCardWidth);
      for (let i = 1; i < data.length; i++) {
        console.log("Waiting list: " + data[i]);
        this.activeList.push(data[i]);
      }
    },
    getDisplayWaitingList() {
      this.activeList = [];
      displayService.getWaitingList(this.queues_ids).then(
        function (data) {
          console.log("data: " + data);
          if (data.totalWaiting > 0) {
            console.log("length waiting list: " + data.waiting_list.length);
            this.setWaitingListCardWidth(data.waiting_list);
            console.log("width:" + this.waitingListCardWidth);
            for (let i = 1; i < data.waiting_list.length; i++) {
              console.log(
                "Waiting list: " + data.waiting_list[i].public_identifier
              );
              this.activeList.push(data.waiting_list[i].public_identifier);
            }
            console.log("activeList_______________");
            console.log(this.activeList);
            console.log(this.activeList[0]);
            // if(this.activeList){
            //     this.ticketNumber = this.activeList.public_identifier;
            //     this.statusUpdateTimestamp = this.activeList.statusUpdateTimestamp;
            //     this.estimatedTimeToSpend = this.activeList.estimatedTimeToSpend;
            //     this.counter = this.activeList.counter_id;

            //     setInterval(function () {
            //         this.calculateTimeLeft()
            //     }.bind(this), 1000);
            //     this.calculateTimeLeft();
            // }
          }
        }.bind(this)
      );
    },
    calculateTimeLeft() {
      let minutesDiff = Math.round(
        this.$moment
          .duration(
            this.$moment(this.statusUpdateTimestamp)
              .add(this.estimatedTimeToSpend, "minutes")
              .diff(this.$moment())
          )
          .asMinutes()
      );
      this.timeLeft = minutesDiff >= 1 ? minutesDiff : 1;
    },
  },
  computed: {},
  mounted() {
    this.colorPrimary = this.config.color;
    this.colorSecondary = this.config.colorSecondary;
    this.colorText = this.config.colorText;
    console.log("ids: " + this.queues_ids);
    if (this.tickets.length === 1) this.heightCard = 100;
    else this.heightCard = 95 / this.tickets.length;
    console.log("height :" + this.heightCard);
    console.log("Get Waiting List");
    this.getDisplayWaitingList();
    // this.setActiveList(this.nextTickets);
    console.log("test" + this.activeList.length);

    this.config = JSON.parse(
      JSON.parse(localStorage.getItem("display")).display.config
    );

    if (JSON.parse(localStorage.getItem("display")).display.show_approx_time) {
      this.show_approx_time = JSON.parse(
        localStorage.getItem("display")
      ).display.show_approx_time;
    }
  },
};
</script>
<style lang="scss" scoped>
.tickets-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  padding: 0 1em 0 1em;
  text-align: center;
  .solo-ticket {
    height: 75vh;
    display: flex;
    align-items: center;
    .ticket-top {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 25%;
      border-radius: 1rem 1rem 0 0;
      padding: 0 0.25em 0 0.25em;
      margin-top: 0.125em;
      font-size: 3rem;
      font-weight: bold;
      text-align: center;
      text-transform: uppercase;
    }
    .ticket-bottom {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 75%;
      border-radius: 0 0 1rem 1rem;
      text-align: center;
      text-transform: uppercase;
      font-weight: 200;
      font-family: "Digital Numbers", serif;
    }
  }
  .waiting-tickets {
    width: 100%;
    height: 25vh;
    text-transform: uppercase;
    text-align: center;
    h3 {
      text-transform: uppercase;
      padding: 0 0 0.25em 0;
      font-weight: bold;
      font-size: 2em;
    }
    .waiting-ticket-list {
      width: 100%;
      font-family: "Digital Numbers", serif;
      font-weight: 200;
      table {
        width: 100%;
        border-collapse: separate;
        border-spacing: 0.25em 0;
      }
      td {
        padding: 0.125em 0.25em 0.125em 0.25em;
        border-radius: 0.75em 0 0.75em 0;
        text-align: center;
      }
    }
  }
  .tickets {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .ticket {
      width: 49%;
      height: 90%;
      .ticket-top {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 30%;
        background-color: #02a3de;
        border-radius: 1rem 1rem 0 0;
        font-size: 1.75rem;
        font-weight: bold;
        text-align: center;
        text-transform: uppercase;
      }
      .ticket-bottom {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 70%;
        background-color: #6f42c1;
        border-radius: 0 0 0.75rem 0.75rem;
        font-size: 4rem;
        text-align: center;
        text-transform: uppercase;
        font-weight: 200;
        font-family: "Digital Numbers", serif;
      }
    }
  }
}
</style>
